import { render, staticRenderFns } from "./AlertLogUser.vue?vue&type=template&id=38898254&"
import script from "./AlertLogUser.vue?vue&type=script&lang=js&"
export * from "./AlertLogUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports